package Structs


import DataBase.UINKDBInterface
import Utils.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import myName

@myName("ClientTaxNoteData")
@Serializable
data class ClientTaxNoteData(
    val value: Float,
    val fill_type: Int = 0,
    @Serializable(with = ClientTaxNoteDetailsSerializer::class)
    var details: String = "",
    // var (was val): the web sets .taxPaid on the result of
    // createTaxNoteDataFromProducts; the LEGACY JS backend allowed it because
    // constructor vals were plain writable fields. IR needs a real setter.
    var taxPaid: Float? = null,
    val amount: Float? = null
) {
    val fillTaxNoteType: FillTaxNoteType = fill_type.let { FillTaxNoteType.HAND.convert(it) }
    fun getValueBefore(date: String = DatesManipulator.dateNowNoHour(),zeroTax:Boolean=true): Float {
        val tp = taxPaid // local capture: taxPaid is now a var (no smart-cast)
        if (tp != null && tp != 0f  || tp==0f && zeroTax)
            return value - tp!!

        val tax = UINKDBInterface.activeDB.tax.get(date)
        return value / tax
    }

    fun toJson(): JsonObject {
        val map: MutableMap<String, JsonPrimitive> = mutableMapOf()
        map["value"] = JsonPrimitive(roundToDecimals( value,2).toString())
        map["fill_type"] = JsonPrimitive(fill_type.toString())
        map["details"] = JsonPrimitive(
            if (fillTaxNoteType == FillTaxNoteType.PRODUCTS) {
                details.replace("\"", "@") //issue with inserting json inside json as string
            } else
                details

        )
        taxPaid?.let {
            map["taxPaid"] = JsonPrimitive(roundToDecimals( it,2).toString())
        }
        amount?.let {
            map["amount"] = JsonPrimitive(roundToDecimals( it,2).toString())
        }
        return JsonObject(map)
    }

    companion object {
        fun createFromJson(js: String): List<ClientTaxNoteData> {
            val trimmed = js.trim()
            if (trimmed.isEmpty() || trimmed == "[]" || trimmed == "null" || trimmed == "None") {
                return emptyList()
            }
            val json = getJsonWithConfig()
            fun decodeOne(el: JsonElement): ClientTaxNoteData =
                json.decodeFromJsonElement(serializer(), el)
            return when (val element = json.parseToJsonElement(trimmed.replace("\\'", "'"))) {
                is JsonNull -> emptyList()
                is JsonArray -> element.map { decodeOne(it) }
                is JsonObject -> listOf(decodeOne(element))
                else -> emptyList()
            }
        }

        fun toJsonArrayString(noteData: List<ClientTaxNoteData>): String {
            return if (noteData.isEmpty()) {
                "[]"
            } else {
                val payload = noteData.map {
                    getJsonWithConfig().encodeToJsonElement(JsonObject.serializer(), it.toJson()).toString()
                }.joinToString(",")
                return "[$payload]"
            }

        }
    }
}
